export default __webpack_public_path__ + "static/media/postgresql.ae92b576b8ea41666538c0756df27969.svg";